var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "controls",
  "use": "controls-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"controls\"><g fill=\"#000\" fill-rule=\"evenodd\" transform=\"translate(0 1)\"><path fill-rule=\"nonzero\" d=\"M0 9h20V7H0zM0 15h20v-2H0zM0 3h20V1H0z\" /><circle cx=\"5\" cy=\"8\" r=\"2\" stroke=\"#000\" /><circle cx=\"11\" cy=\"2\" r=\"2\" stroke=\"#000\" /><circle cx=\"15\" cy=\"14\" r=\"2\" stroke=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol